<template>
    <FilterBase :title>
        <FilterList>
            <FilterItemWithImage
                v-for="shape in filter"
                :key="shape.shape.systemCode"
                :add-link="getRouteAddCentreStoneShape(shape.shape.systemCode)"
                :disabled="disabled"
                :image="shape.shape.icon?.url"
                :label="shape.shape.translation.name"
                :remove-link="getRouteRemoveCentreStoneShape()"
                :selected="isSelected(filterMapperShape(shape))"
                :total-results="shape.totalResults"
            />
        </FilterList>
    </FilterBase>
</template>

<script lang="ts" setup>
import type { FilterShapeFragment, StoneShapeCode } from '@/graphql/api'
import { filterMapperShape } from '@/domain/product/ring/engagement'
import type { ButtonRouteRelative } from '../../buttons/useThButton'

import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import FilterItemWithImage from '../FilterItemWithImage.vue'
import FilterList from './layout/FilterList.vue'

const props = defineProps<{
    filter: FilterShapeFragment[]
    selected: StoneShapeCode[]
    getRouteAddCentreStoneShape: (shape: StoneShapeCode) => ButtonRouteRelative
    getRouteRemoveCentreStoneShape: () => ButtonRouteRelative
    disabled?: boolean
    title?: string
}>()

const isSelected = (item: StoneShapeCode) => props.selected.includes(item)

// const emit = defineEmits<{
//     (e: 'update:modelValue', v: StoneShapeCode[] | null): void
// }>()

// const toggleValue = (v: FilterShapeFragment) => {
//     const value = props.modelValue?.find((item) => item === v.shape.systemCode)

//     if (value) {
//         emit('update:modelValue', [])
//     } else {
//         emit('update:modelValue', [v.shape.systemCode])
//     }
// }
</script>
